module.exports = __webpack_public_path__ + "img/user.9769d17c.jpg";